<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/empresa/desafios'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de desafios"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode construir novos desafios, que serão
              disponibilizadas para os colaboradores se inscreverem. Os
              colaboradores poderam submeter seus projetos para posterior
              avaliação pela empresa.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-9">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    <i class="far fa-lightbulb mr-2"></i> Novo desafio
                  </h3>
                </div>
              </div>
            </div>
            <div class="vld-parent" ref="form_container">
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-6">
                  <base-input
                    label="Título do desafio*"
                    placeholder="Digite o título"
                    v-model="model.title"
                  />
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label d-block mb-3"
                    >Desafio ativo?
                    <i
                      class="fas fa-info-circle ml-1"
                      v-tooltip="
                        'Desafios <b>ativos</b> são exibidos para os colaboradores se as <b>datas de ínicio e fim</b> forem respeitadas.'
                      "
                    ></i
                  ></label>
                  <base-input>
                    <base-switch
                      v-bind:value="model.is_active"
                      @input="switchChangedHandler($event, 'is_active')"
                    />
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label d-block"
                    >Data de ínicio*
                    <base-button
                      size="sm"
                      type="link"
                      class="p-0 m-0 ml-2 float-right"
                      @click="setCurrentDate()"
                    >
                      Usar data atual
                    </base-button></label
                  >
                  <base-input
                    addonLeftIcon="fas fa-calendar"
                    type="date"
                    v-model="model.start_date"
                  />
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label d-block">Data de fim*</label>
                  <base-input
                    addonLeftIcon="fas fa-calendar"
                    type="date"
                    v-model="model.end_date"
                  />
                </div>
                <div class="col-lg-12">
                  <base-input label="Descrição do desafio*">
                    <textarea
                      rows="2"
                      class="form-control"
                      placeholder="Descreva aqui a desafio"
                      v-model="model.description"
                    >
                    </textarea>
                  </base-input>
                </div>
              </div>
              <hr class="mt-2 mb-4" />
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">Avaliadores</h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-12 mb-4 pb-2">
                  <div class="vld-parent" ref="evaluators_form">
                    <label class="form-control-label d-block">
                      Avaliadores vinculados ao desafio*
                    </label>
                    <multiselect
                      class="categories_select"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      track-by="name"
                      selectLabel="Clique para selecionar"
                      deselectLabel="Clique para remover"
                      placeholder="Busque por um avaliador (nome)"
                      label="name"
                      noResult="Nenhum resultado encontrado"
                      :options="evaluators"
                      v-model="selectedEvaluators"
                    >
                      <template slot="option" slot-scope="props">
                        <i class="fa fa-tag mr-2"></i>
                        {{ props.option.name }}
                        <span class="float-right text-xs">
                          {{ props.option.position }}
                        </span>
                      </template>
                      <span slot="noResult">Nenhum resultado encontrado</span>
                      <span slot="noOptions"
                        >Não há avaliadores cadastrados</span
                      >
                    </multiselect>
                  </div>
                </div>
              </div>
              <hr class="mt-0 mb-4" />
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-0">Regras do desafio</h6>
              </div>
              <div class="row ml-lg-2 mt-4">
                <div class="col-lg-6">
                  <label class="form-control-label d-block"
                    >Mínimo de pessoas na equipe*</label
                  >
                  <base-input
                    addonLeftIcon="fas fa-user-friends"
                    type="number"
                    placeholder="Digite o minimo de pessoas"
                    v-model="model.min_per_team"
                  />
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label d-block"
                    >Máximo de pessoas na equipe*</label
                  >
                  <base-input
                    addonLeftIcon="fas fa-users"
                    type="number"
                    placeholder="Digite o máximo de pessoas"
                    v-model="model.max_per_team"
                  />
                </div>
              </div>
              <hr class="mt-5 mb-3" />

              <div class="row">
                <div class="col-12 text-center mt-3" v-if="error">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
                <div class="col-12 text-center mt-3">
                  <span
                    v-tooltip="
                      isValidModel
                        ? 'Clique para criar a enquete'
                        : 'Preencha os <b>campos obrigatórios</b> (<b>*</b>) para continuar'
                    "
                  >
                    <base-button
                      type="primary"
                      @click="handleSubmit()"
                      :custom="true"
                      :disabled="!isValidModel"
                    >
                      Criar desafio
                    </base-button>
                  </span>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";
import Multiselect from "vue-multiselect";

export default {
  name: "enquetes-form",
  components: {
    multiselect: Multiselect
  },
  data() {
    return {
      model: {
        title: "",
        is_active: true,
        description: "",
        start_date: "",
        end_date: "",
        min_person: "",
        max_person: "",
        evaluators_ids: []
      },
      selectedEvaluators: [],
      evaluators: [],
      filterByEvaluator: (option, search) => {
        const temp = search.toLowerCase();
        let match = false;
        return option.name.toLowerCase().indexOf(temp) > -1 || match;
      },
      error: ""
    };
  },
  async mounted() {
    await this.loadEvaluators();
  },
  methods: {
    async loadEvaluators() {
      const loader = this.$loading.show({
        container: this.$refs.evaluators_form,
        width: 90,
        height: 90
      });
      try {
        const {
          data: { collaborators }
        } = await api.get(`/company/collaborators`);
        if (collaborators) {
          this.evaluators = collaborators;
        } else this.empty = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar os desafios");
      }
    },
    async handleSubmit() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.form_container,
        width: 90,
        height: 90
      });
      try {
        const challenge = this.model;
        challenge.evaluators_ids = this.selectedEvaluators.map(categoria => {
          return categoria.user_id;
        });
        await api.post(`/company/challenges`, {
          title: challenge.title,
          description: challenge.description,
          active: challenge.active,
          start_date: challenge.start_date,
          end_date: challenge.end_date,
          max_per_team: challenge.max_per_team,
          min_per_team: challenge.min_per_team,
          evaluators: challenge.evaluators_ids
        });
        this.$toasted.show("Desafio atualizado com sucesso");
        this.$router.push(`/empresa/desafios`);
      } catch (e) {
        const strError =
          "Ocorreu um erro ao salvar o desafio. Tente novamente.";
        const hasErrorMessage =
          e.response && e.response.data && e.response.data.message;
        this.error = hasErrorMessage ? e.response.data.message : strError;
        this.$toasted.error(strError);
      }
      loader.hide();
    },
    setCurrentDate() {
      this.model.start_date = this.moment().format("YYYY-MM-DD");
    },
    switchChangedHandler(event, prop) {
      if (typeof event === "boolean") this.model[prop] = event;
    }
  },
  computed: {
    isValidModel() {
      return (
        this.model.title &&
        this.model.description &&
        this.model.start_date &&
        this.model.end_date &&
        this.selectedEvaluators
      );
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.categories_select.multiselect {
  background-color: #fff;
  background-clip: padding-box;
}
.categories_select.multiselect .vs__dropdown-toggle {
  padding: 0.5rem 0.1rem;
  min-width: 100%;
}
</style>
